<div class="panel-container">
  <div class="panel-header-container">
    <div class="panel-header">
      SUBMISSION RULES
    </div>
    @if (hasSubmissionRuleResults) {
      <div class="panel-sub-header">
        The items in <span class="red-text">Red</span> must be fixed before the spread can be completed. Items in
        <span class="yellow-text">Yellow</span> do not have to be fixed
        but should be checked.
      </div>
    }
  </div>
  <div class="rule-result-list-container">
    @if (hasSubmissionRuleResults) {
      @for (periodSummary of ruleResultsSummary | keyvalue; track periodSummary) {
        <div class="period-section">
          <div class="period-date-title">{{ periodSummary.key }}</div>
          @for (result of periodSummary.value; track result) {
                    <div class="rule-result" [ngClass]="{
                'hard-stop': result.action == SubmissionRuleActions.HARD_STOP,
                'soft-stop': result.action == SubmissionRuleActions.SOFT_STOP,
                }">
              <div class="left-content">
                            <i class="fa" [ngClass]="{
                        'fa-triangle-exclamation': result.action == SubmissionRuleActions.SOFT_STOP,
                        'fa-circle-xmark': result.action == SubmissionRuleActions.HARD_STOP,
                        }"></i>
              </div>
              <div class="right-content">
                <div class="rule-title">
                  {{ result.lineItemLabel }} = {{ result.value }}
                </div>
                <div class="rule-sub-title">
                  {{ result.message }}
                </div>
              </div>
            </div>
          }
        </div>
      }
    } @else {
      <div class="submission-rule-empty-state">
        <i class="fa fa-check-circle"></i>
        <div class="title">All Rules Passing</div>
        <div class="sub-title">All submission rules are passing for this tab</div>
      </div>
    }
  </div>
</div>
